/* Gift Reggie product-page button enhancements.

   1) Registry "Item on Registry" state: the app has no persistent
      already-on-registry state (registries allow quantities), so we remember
      additions for this visit: when the app shows its "Added to Registry"
      feedback we record the variant in sessionStorage and keep the
      qj-gr--on-registry class on the button. qj-gr-buttons.css swaps the
      label text based on that class.

   2) Wishlist error helper: when adding fails the app only flashes a hidden
      "Error" label and greys the button. The usual cause is a customer who
      hasn't set up their wishlist yet, so on error we ask the app's own API
      whether their wishlist exists and show a message below the buttons —
      with a link to the wishlist page — or a generic try-again note for
      other failures. Texts come from Theme settings → "Registry & Wishlist
      buttons" via the #qj-gr-config JSON emitted by main-product.liquid. */
(function () {
  function init() {
    var i18n = { registry: {}, wishlist: {} };
    try {
      i18n = JSON.parse(document.getElementById('gift_reggie_data').textContent).i18n || i18n;
    } catch (e) { /* fall back to defaults below */ }
    var successAdd = (i18n.registry && i18n.registry.successAdd) || 'Added to Registry';
    var wlError = (i18n.wishlist && i18n.wishlist.error) || 'Error';

    var cfg = {
      noWishlistMsg: "Looks like you haven't set up your wishlist yet.",
      noWishlistLink: 'Create your wishlist here',
      genericError: 'Something went wrong — please try again.'
    };
    try {
      var el = document.getElementById('qj-gr-config');
      if (el) {
        var parsed = JSON.parse(el.textContent);
        for (var k in parsed) if (parsed[k]) cfg[k] = parsed[k];
      }
    } catch (e) { /* keep defaults */ }

    /* ---- registry visit-state ---- */
    var KEY = 'qj_gr_registry_added';
    function stored() {
      try { return JSON.parse(sessionStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
    }
    function remember(v) {
      var list = stored();
      if (v && list.indexOf(v) === -1) {
        list.push(v);
        try { sessionStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
      }
    }
    function currentVariant() {
      // Scope to the main product section: the header mega menu and the
      // recommendation carousels carry /cart/add forms for OTHER products,
      // and a page-wide query returns one of those first (2026-09-03).
      var input = document.querySelector('section[id^="MainProduct-"] form[action*="/cart/add"] [name="id"]');
      if (input && input.value) return String(input.value);
      var m = location.search.match(/[?&]variant=(\d+)/);
      return m ? m[1] : '';
    }

    /* ---- wishlist error helper ---- */
    var helpChecking = false;
    function showWishlistHelp(noList, anchorButton) {
      var old = document.getElementById('qj-gr-wl-help');
      if (old) old.remove();
      var area = anchorButton.closest('.giftreggie-pdp-cta-area, .giftreggie-pdp-button-area') || anchorButton.parentNode;
      var div = document.createElement('div');
      div.id = 'qj-gr-wl-help';
      div.className = 'qj-gr-help';
      div.setAttribute('role', 'alert');
      if (noList) {
        var span = document.createElement('span');
        span.textContent = cfg.noWishlistMsg + ' ';
        var a = document.createElement('a');
        a.href = '/apps/giftregistry/wishlist';
        a.textContent = cfg.noWishlistLink;
        div.appendChild(span);
        div.appendChild(a);
      } else {
        div.textContent = cfg.genericError;
      }
      area.parentNode.insertBefore(div, area.nextSibling);
    }
    function hideWishlistHelp() {
      var old = document.getElementById('qj-gr-wl-help');
      if (old) old.remove();
    }
    function onWishlistError(button) {
      if (helpChecking) return;
      helpChecking = true;
      // Ask the app's own API whether this customer's wishlist exists
      fetch('/apps/giftregistry/api/wishlist')
        .then(function (r) { showWishlistHelp(!r.ok, button); })
        .catch(function () { showWishlistHelp(true, button); })
        .then(function () { setTimeout(function () { helpChecking = false; }, 3000); });
    }

    /* ---- shared poll ---- */
    function sync() {
      var v = currentVariant();
      var on = !!v && stored().indexOf(v) !== -1;
      document.querySelectorAll('.giftreggie-pdp-registry-cta--button').forEach(function (b) {
        if (b.textContent === successAdd) {
          remember(v);
          on = true;
        }
        b.classList.toggle('qj-gr--on-registry', on);
      });
      document.querySelectorAll('.giftreggie-pdp-wishlist-cta--button').forEach(function (b) {
        if (b.textContent === wlError) {
          onWishlistError(b);
        } else if (b.classList.contains('giftreggie-pdp-wishlist-cta--in-wishlist')) {
          // item made it onto the wishlist — any earlier help message is stale
          hideWishlistHelp();
        }
      });
    }
    sync();
    setInterval(sync, 300);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
